import { createContext } from 'react'

export type BrokersMembersTransactionsContextType = {
  enrollmentId: string
  memberId: string
  isUserThatchAdmin: boolean
  isMemberTransactionsViewV2Enabled: boolean
  latestPlanYear: number
  declareLossesAtTransactionLevel: boolean
}

const BrokersMembersTransactionsContext = createContext<BrokersMembersTransactionsContextType>({
  enrollmentId: '',
  memberId: '',
  isUserThatchAdmin: false,
  isMemberTransactionsViewV2Enabled: false,
  latestPlanYear: 0,
  declareLossesAtTransactionLevel: false,
})

export default BrokersMembersTransactionsContext
